module.exports = __webpack_public_path__ + "img/banner3.2d4475d6.jpg";